import { FC, useMemo } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Autocomplete, { AutocompleteProps } from 'components/Autocomplete';

import { RegionSelect_data$key } from '__generated__/RegionSelect_data.graphql';

type Props = Omit<AutocompleteProps, 'options'> & {
  data: RegionSelect_data$key;
  countryId?: string;
};

const RegionSelect: FC<Props> = ({ countryId, data, ...props }) => {
  const { regions } = useFragment(
    graphql`
      fragment RegionSelect_data on Query {
        regions {
          id
          name

          country {
            id
          }
        }
      }
    `,
    data
  );

  const options = useMemo(
    () =>
      countryId
        ? regions.filter(({ country }) => country.id === countryId)
        : regions,
    [countryId, regions]
  );

  return <Autocomplete options={options} {...props} />;
};

export default RegionSelect;
